import { AdminDashboard } from "@/components/admin-dashboard";

const Admin = () => {
  return <AdminDashboard />;
};

export default Admin;